export default "__VITE_ASSET__BVcYWUHL__"